import { IError, LoadingOverlay, useToast } from '@comptia-sso/core';
import { ReactElement, useEffect } from 'react';
import { useParams } from 'react-router-dom';

// Components.
import { InstructorApproverDetails } from '../../components/InstructorApproverDetails';
import { InstructorApproverEditHeader } from './InstructorApproverEditHeader';

// Hooks.
import { useInstructorApprover, useAccount } from 'hooks';

// Layouts.
import { ContentLayout } from 'layouts';

export const InstructorApproverEditView = (): ReactElement => {
  const { id } = useParams();
  const [account] = useAccount();
  const [popToast] = useToast();
  const [instructorApprover, { error, isLoading }] = useInstructorApprover(id);

  useEffect(() => {
    if (error) {
      popToast(
        (error as IError)?.message ||
          'An unexpected error occurred. Please try again later.',
      );
    }
  }, [error]);

  return (
    <>
      <ContentLayout
        header={
          <InstructorApproverEditHeader
            institutionId={instructorApprover?.institutionId}
          />
        }
        content={
          !isLoading &&
          !error && (
            <InstructorApproverDetails
              instructorApprover={instructorApprover}
              account={account}
              mode="edit"
            />
          )
        }
      />
      <LoadingOverlay isOpen={isLoading} text="Please Wait" />
    </>
  );
};
